// removed by extract-text-webpack-plugin
module.exports = {"button":"button_1IzKG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/button/style.css
 ** module id = 932
 ** module chunks = 0
 **/